// extracted by mini-css-extract-plugin
module.exports = {"root":"DataNotFound_root__jO9q7"};